import api from '../api';

import { ParamsBodyEditCustomerAppAccess } from 'utils/typeServices';

export const PostEditCustomerAppAccess = async ({ token, body }: { token: string, body: ParamsBodyEditCustomerAppAccess }) => {
    const bodyJson = JSON.stringify(body);

    try {
        const { data } = await api.post<{ Data: any }>('v1/Cliente/EditCustomerAppAccess', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error:any) {
        console.error('ERROR', error.response.data.Data);
        return { data: null, error_msg: error.response.data.Data };
    }
}
